<script>
import { mapGetters, mapActions } from 'vuex'
import LABELS from '@/constants/labels'
import { avatarPart as avatarData } from '@/constants/data'
import { uniqueId } from '@/helpers/site'

export default {
  name: 'selectAvatar',
  data() {
    return {
      avatarData,
      addScreenOpen: false,
      avatarList: {},
      selectedId: '',
      partSelected: 'hair',
      partEdit: null,
      partContentSelected: null,
      defaultRotate: 0,
      defaultScale: 0.5,
    }
  },
  methods: {
    ...mapActions('settings', [
      'setAvatars',
      'saveToStorage',
      'setLayout',
      'setExport',
      'setModules',
    ]),
    loadData({ data, reset = false }) {
      this.partContentSelected = reset
        ? {
            skin: {
              id: 'type-1',
              value: '#FFEBD4',
            },
            contour: {
              id: 'type-1',
              value: 'type-1',
            },
            hair: {
              id: 'type-14',
              value: 'type-14',
              color: '#333333',
            },
            eyebrows: {
              id: 'type-4',
              value: 'type-4',
              position: 'm',
              color: '#333333',
            },
            eyes: {
              id: 'type-1',
              value: 'type-1',
              position: 'm',
              color: '#000000',
            },
            nose: {
              id: 'type-3',
              value: 'type-3',
              position: 'm',
              color: '#DAB595',
            },
            mouth: {
              id: 'type-8',
              value: 'type-8',
              position: 'm',
            },
            clothes: {
              id: 'type-1',
              value: 'type-1',
            },
            mustache: {
              id: 'type-none',
              value: 'type-none',
              position: 'm',
              color: '#000000',
            },
            beard: {
              id: 'type-none',
              value: 'type-none',
              position: 'm',
              color: '#000000',
            },
            glasses: {
              id: 'type-none',
              value: 'type-none',
              position: 'm',
              color: '#000000',
            },
            eyeshadow: {
              id: 'type-none',
              value: 'type-none',
              position: 'm',
              color: '#a52a2a',
            },
            cheek: {
              id: 'type-none',
              value: 'type-none',
              position: 'm',
            },
            wrinkle: {
              id: 'type-none',
              value: 'type-none',
              position: 'm',
              color: '#40281d',
            },
            mole: {
              id: 'type-none',
              value: 'type-none',
              position: 'm',
            },
          }
        : JSON.parse(JSON.stringify(data))
    },
    resetAdd() {
      this.partSelected = 'hair'
      this.partContentSelected = null
      this.partEdit = null
      this.addScreenOpen = false
    },
    saveAvatar() {
      const svg = this.$refs.avatar.$el

      svg.setAttribute('width', 350)
      svg.setAttribute('height', 350)

      const svgData = new XMLSerializer().serializeToString(svg)

      const encodeData = window.btoa(svgData)

      if (this.partEdit !== null) {
        this.$set(this.avatarList, this.partEdit, {
          ...this.avatarList[this.partEdit],
          data: { ...this.partContentSelected },
          src: encodeData,
        })
      } else {
        const id = uniqueId('avatar')
        this.avatarList = {
          ...this.avatarList,
          [id]: {
            id,
            data: { ...this.partContentSelected },
            format: 'data:image/svg+xml;base64,',
            src: encodeData,
            rotation: 0,
            scaleX: 0.5,
            scaleY: 0.5,
            x: 0,
            y: 0,
            show: true,
          },
        }
      }
    },
    handleAddScreen() {
      this.loadData({ reset: true })
      this.selectedId = ''
      this.partSelected = 'hair'
      this.addScreenOpen = true
      window.scrollTo(0, 0)
    },
    handleCloseAddScreen() {
      this.resetAdd()
      window.scrollTo(0, 0)
    },
    handleAcceptAddScreen() {
      this.saveAvatar()
      this.selectedId = ''
      this.resetAdd()
    },
    handleDeleteAvatar(index) {
      this.selectedId = ''
      this.$delete(this.avatarList, index)
    },
    handleEditAvatar(index) {
      this.selectedId = ''
      this.loadData({ data: this.avatarList[index].data })
      this.partEdit = index
      this.addScreenOpen = true
    },
    handleSelectAvatar(id, show) {
      show && (this.selectedId = id)
    },
    selectChange(value) {
      if (value) {
        const currentObject = this.avatarList[value]
        this.selectedId = value

        this.defaultRotate = +currentObject.rotation
        this.defaultScale = +currentObject.scaleX
      } else {
        this.selectedId = ''
      }
    },
    handleRotate(value) {
      if (this.selectedId) {
        this.avatarList[this.selectedId].rotation = +value
        this.defaultRotate = +value
      }
    },
    handleScale(value) {
      if (this.selectedId) {
        const currentObject = this.avatarList[this.selectedId]
        currentObject.scaleX = +value
        currentObject.scaleY = +value

        this.defaultScale = +value
      }
    },
    handleSaveAll() {
      this.setAvatars(this.avatarList)
      this.saveToStorage()
      this.$router.push({
        name: 'preview',
      })
    },
    setPart(key) {
      this.partSelected = key
    },
    setPartContent(value) {
      const data = {
        id: value.id,
        value: value.value,
      }

      this.partContentSelected[this.partSelected] = {
        ...this.partContentSelected[this.partSelected],
        ...data,
      }
    },
    selectPosition(value) {
      this.partContentSelected[this.partSelected].position = value
    },
    selectColor(color) {
      this.partContentSelected[this.partSelected].color = color
    },
    showPopupConfirmDelete() {
      this.$nextTick(() => {
        this.$refs.confirmDeletePopup &&
          this.$refs.confirmDeletePopup.show({
            title: this.mappingLabels.deleteModalTitle,
            message: this.mappingLabels.deleteModalMessage,
            textCancelButton: this.mappingLabels.cancelText,
            textSubmitButton: this.mappingLabels.confirmText,
          })
      })
    },

    resetData() {
      this.setLayout({ reset: true })
      this.setModules({ reset: true })
      this.setExport({ reset: true })
      this.saveToStorage()
    },

    handleClearData() {
      this.$nextTick(() => {
        const objectKeys = []
        for (let objectKey in this.avatarList) {
          objectKeys.push(objectKey)
        }
        objectKeys.forEach(item => {
          this.$delete(this.avatarList, item)
        })
        this.$refs.confirmDeletePopup.hide()
        this.$router.push({ name: 'preview' })
      })
    },
  },
  computed: {
    ...mapGetters('settings', [
      'getBackground',
      'getAvatars',
      'getTexts',
      'getStamps',
    ]),
    mappingLabels() {
      return LABELS
    },
  },
  created() {
    this.avatarList = this.getAvatars
  },
}
</script>

<template>
  <div>
    <s-header :hasPreview="true">{{
      mappingLabels.createAvatarTitle
    }}</s-header>
    <div class="show-avatar">
      <div class="show-avatar__list" v-if="!addScreenOpen">
        <div class="show-avatar__containerImg">
          <div class="show-avatar__img">
            <!-- <a class="delete-avt__btn"  @click="showPopupConfirmDelete()">
              <img :src="require('@/assets/images/avatar/trash_avt.svg')" />
              やり直す
            </a> -->
            <s-preview
              :backgroundDraw="getBackground"
              :avatarDraw="avatarList"
              :textDraw="getTexts"
              :stampDraw="getStamps"
              currentMove="avatar"
              :selectedName="selectedId"
              @onchangeSelect="selectChange"
            />
          </div>
        </div>
        <div class="avatar_layout">
          <div class="avatar_layout_wrapper">
            <div class="show-avatar__input-range">
              <s-range-input
                :label="'角度'"
                :min="-180"
                :max="180"
                :value="defaultRotate"
                :step="15"
                :disabled="!selectedId"
                @on-input="handleRotate"
              />
              <s-range-input
                :label="'大きさ'"
                :min="0.25"
                :max="3"
                :value="defaultScale"
                :step="0.01"
                :disabled="!selectedId"
                @on-input="handleScale"
              />
            </div>
            <div
              class="show-avatar__items"
              v-if="Object.values(avatarList).length > 0"
            >
              <div
                v-for="(avatar, idx) of avatarList"
                :key="`avatar${idx}`"
                :class="['avatar', { selected: selectedId === avatar.id }]"
                @click="handleSelectAvatar(avatar.id, avatar.show)"
              >
                <div class="avatar-img">
                  <img
                    :src="`data:image/svg+xml;base64,${avatar.src}`"
                    alt="avatar-demo"
                  />
                </div>
                <div class="options">
                  <s-checkbox v-model="avatar.show" class="w-0">{{
                    mappingLabels.showAvatar
                  }}</s-checkbox>
                  <button
                    class="s-button blue-btn change-btn"
                    @click="handleEditAvatar(idx)"
                  >
                    <span class="icon"><x-icon-edit /></span>
                    <label>{{ mappingLabels.editAvatar }}</label>
                  </button>
                </div>
              </div>
            </div>
            <div
              class="show-avatar__btns"
              v-if="Object.values(avatarList).length < 2"
            >
              <button
                type="button"
                class="s-button add-avatar-btn blue-btn"
                @click="handleAddScreen"
              >
                <span>+</span>
                <label>{{ mappingLabels.addAvatar }}</label>
              </button>
            </div>
          </div>
        </div>
        <s-navigate-bar
          class="navigate-bar-fixed"
          @leftClick="$router.push({ name: 'preview' })"
          @rightClick="handleSaveAll"
          >{{ mappingLabels.decideAndBackToPreviewText }}
        </s-navigate-bar>
        <s-modal-confirm
          ref="confirmDeletePopup"
          @submit="handleClearData"
        ></s-modal-confirm>
      </div>
      <div class="show-avatar__add" v-else>
        <div class="frame-view">
          <div class="avatar-wrapper">
            <s-layout-avatar ref="avatar" :data="partContentSelected" />
          </div>
        </div>
        <div class="show-avatar_list-wrap">
          <s-part-tab-wrapper @set-tab="setPart">
            <template v-slot:content>
              <s-part-tab
                v-for="(part, idxp) of avatarData"
                :key="`tab${idxp}`"
                :title="part.name"
                :data="part"
                :selectedData="partContentSelected[part.id]"
                :selected="part.id === partSelected"
                @select-pos="selectPosition"
                @select-part="setPartContent"
                @select-color="selectColor"
                @close-add-screen="handleCloseAddScreen"
                @accept-add-screen="handleAcceptAddScreen"
              />
            </template>
          </s-part-tab-wrapper>
          <!-- <s-navigate-bar
            @leftClick="handleCloseAddScreen"
            @rightClick="handleAcceptAddScreen"
            >{{ mappingLabels.completeText2 }}
          </s-navigate-bar> -->
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './showAvatar.scss';
</style>
